import styled from 'styled-components';
import { Wrapper as StatusBanner } from '@spa/shared/components/Unisystem/StatusBanner/styles';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-12u4vnd-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";& + p{font-size:", ";line-height:", ";color:", ";margin-top:", ";}}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
});
export var SectionItemList = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-1"
})(["display:flex;flex-direction:column;"]);
export var SectionItemWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-2"
})(["display:flex;justify-content:space-between;padding-bottom:", ";& + p{font-size:", ";line-height:", ";margin-bottom:", ";color:", ";&:not(:last-of-type){margin-bottom:", ";border-bottom:1px solid ", ";padding-bottom:", ";}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.sections.separator.color;
}, function (props) {
  return props.theme.space(2);
});
export var Sections = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-3"
})(["width:100%;padding:", " ", ";border:1px solid ", ";border-radius:8px;display:flex;flex-direction:column;", ";&:not(:last-of-type){margin-bottom:", ";}&:first-of-type{margin-top:", ";}h3{font-size:", ";line-height:", ";font-weight:600;color:", ";}", "{margin-top:2px;padding:0;}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.sections.border.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, StatusBanner);
export var Description = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-4"
})(["color:", ";display:flex;flex-direction:row;align-items:center;column-gap:8px;h4{font-size:", ";line-height:", ";}"], function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
export var Value = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-5"
})(["font-size:", ";line-height:", ";text-align:right;font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
export var Bills = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-6"
})(["width:100%;display:flex;flex-direction:column;", ";", " ", "{font-size:", ";line-height:", ";color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4, 'column');
}, function (props) {
  return !props.canShowBillsTotal && "\n    margin-bottom: ".concat(props.theme.space(1), ";\n  ");
}, StatusBanner, function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.servicesExpensesSection.statusBanner.textColor;
});
export var BillsSeparator = /*#__PURE__*/styled.hr.withConfig({
  componentId: "sc-12u4vnd-7"
})(["border:0;border-top:", ";"], function (props) {
  return "1px solid ".concat(props.theme.sections.separator.color);
});
export var BillsTotalWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-8"
})(["display:flex;flex-direction:column;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(1);
});
export var BillsTotal = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-12u4vnd-9"
})(["display:flex;align-items:center;justify-content:space-between;font-size:", ";line-height:", ";border-radius:4px;padding:", " ", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
export var BillsTotalText = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-12u4vnd-10"
})(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(26);
});
export var BillsTotalAmount = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-12u4vnd-11"
})(["font-weight:700;font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});